{
	"v": "5.5.7",
	"meta": { "g": "LottieFiles AE 0.1.20", "a": "", "k": "", "d": "", "tc": "" },
	"fr": 60,
	"ip": 0,
	"op": 79,
	"w": 50,
	"h": 50,
	"nm": "spinner",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [10] },
						{ "t": 80, "s": [0] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 360, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Shape Layer 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [20] },
						{ "t": 80, "s": [10] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 405, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Shape Layer 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [30] },
						{ "t": 80, "s": [20] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 450, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Shape Layer 4",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [40] },
						{ "t": 80, "s": [30] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 495, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Shape Layer 5",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [50] },
						{ "t": 80, "s": [40] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 540, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Shape Layer 6",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [60] },
						{ "t": 80, "s": [50] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 585, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Shape Layer 7",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [0] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [70] },
						{ "t": 80, "s": [60] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 630, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Shape Layer 8",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [70] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 10, "s": [60] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 20, "s": [50] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 30, "s": [40] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [30] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 50, "s": [20] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 60, "s": [10] },
						{ "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 70, "s": [0] },
						{ "t": 80, "s": [70] }
					],
					"ix": 11
				},
				"r": { "a": 0, "k": 675, "ix": 10 },
				"p": { "a": 0, "k": [24.688, 24.938, 0], "ix": 2 },
				"a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ty": "rc",
							"d": 1,
							"s": { "a": 0, "k": [4, 12], "ix": 2 },
							"p": { "a": 0, "k": [0, -4], "ix": 3 },
							"r": { "a": 0, "k": 15, "ix": 4 },
							"nm": "Rectangle Path 1",
							"mn": "ADBE Vector Shape - Rect",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [0.2588, 0.1608, 0.4314, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0.248, -12.664], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Rectangle 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
